import * as React from "react";
const SvgFiRrFarm = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-farm_svg__a)">
      <path
        fill="#062147"
        d="m23.328 8.426-3.001-4.502a4 4 0 0 0-1.752-1.458L13.576.324a4.01 4.01 0 0 0-3.152 0L5.426 2.466a4 4 0 0 0-1.752 1.458L.672 8.426A4 4 0 0 0 0 10.646V19c0 2.758 2.243 5 5 5h14c2.757 0 5-2.242 5-5v-8.354c0-.793-.232-1.56-.672-2.22m-9.749 9.666 3.421-2.8v5.599zM15.198 22H8.801L12 19.383zm-3.199-5.202-3.421-2.798h6.842zm-5-1.506 3.421 2.799-3.421 2.799zm15 3.707c0 1.654-1.346 3-3 3v-7c0-1.653-1.346-3-3-3H8c-1.654 0-3 1.347-3 3v7c-1.654 0-3-1.346-3-3v-8.354c0-.397.116-.78.336-1.11l3.001-4.502c.216-.323.519-.576.876-.729l4.999-2.142a2 2 0 0 1 1.575 0l4.999 2.142c.357.153.661.406.876.73l3.001 4.501c.22.33.336.713.336 1.11zM12 4c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3m0 4c-.551 0-1-.449-1-1s.449-1 1-1 1 .45 1 1c0 .551-.449 1-1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-farm_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFarm;
